module.exports = __webpack_public_path__ + "img/18.61b5470d.jpg";